import { MenuItem } from "react-pro-sidebar";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import list from "../../../images/newDesign/list.svg";
import React, { Fragment, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SideMenuTitle } from "../sideMenu/sideMenuTitle";
import { SideMenu } from "../sideMenu/sideMenu";
import { SideMenuItem } from "../sideMenu/sideMenuItem";
import { constants } from "../../../common/constants/constants";
import { toggleMobileMenuOpened } from "../../../store/common/slice";

export const BuildingsListSidebarMenu = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const menuRef = useRef();
    const allBuildings = useSelector((state) => state.manager.buildings);

    const onItemClick = () => {
        dispatch(toggleMobileMenuOpened());
    }

    return (
        <Fragment>
            {allBuildings.buildings?.length ? <Fragment>
                <MenuItem icon={<img src={list} alt="buildings list"/>} ref={menuRef}>
                    <NavLink className="dropdown-link" to={{ pathname: '' }}>
                        {t('buildings.nav_bar_buildings_list')}
                    </NavLink>
                </MenuItem>
                <SideMenu container={menuRef.current}>
                    <SideMenuTitle
                        label={t('buildings.nav_bar_buildings_list')}
                        icon={list}/>
                    {allBuildings.buildings.map(building => {
                        return <SideMenuItem
                            key={building.buildingID}
                            url={`/${constants.pages.buildingManagerProfileUrl}/${building.buildingID}`}
                            label={building.title}
                            onClick={onItemClick}/>
                    })}
                </SideMenu>
            </Fragment> : null}
        </Fragment>
    );
}
